import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Dashboard() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [userProgress, setUserProgress] = useState(null);
  const [courses, setCourses] = useState([]);  // Ajouter un state pour les cours

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    
    // Appel pour récupérer la progression de l'utilisateur
    axios.get(`${API_URL}/cours/api/user-progress/`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => {
      setUserProgress(response.data);
    })
    .catch(error => {
      console.error("Erreur lors de la récupération des informations utilisateur :", error);
    });

    // Appel pour récupérer la liste des cours disponibles
    axios.get(`${API_URL}/cours/api/courses/`, {
      headers: {
        'Authorization': `Bearer ${token}`  // Ajouter le token JWT ici aussi
      }
    })
    .then(response => {
      setCourses(response.data);  // Mettre à jour les cours dans le state
    })
    .catch(error => {
      console.error("Erreur lors de la récupération des cours", error);
    });
  }, []);

  return (
    <div className="dashboard">
      <h1>Tableau de bord</h1>
      {userProgress ? (
        <div>
          <p>Niveau : {userProgress.level}</p>
          <p>XP : {userProgress.xp_earned}</p>
          <p>Exercices complétés : {userProgress.exercises_completed}</p>
        </div>
      ) : (
        <p>Chargement...</p>
      )}

      <h2>Liste des cours disponibles</h2>
      {courses.length > 0 ? (
        <ul>
          {courses.map(course => (
            <li key={course.id}>
              <h3>{course.title}</h3>
              <p>{course.description}</p>
              <p>Difficulté : {course.difficulty}</p>
              <p>XP fourni : {course.xp_provided}</p>
            </li>
          ))}
        </ul>
      ) : (
        <p>Aucun cours disponible pour le moment.</p>
      )}
    </div>
  );
}

export default Dashboard;
